export const calculateMeasurement = (pixels) => {
    return (pixels / 50) * 3.281;
};
const createMeasurementMarkers = (canvas, groupId, isHorizontal, startPoint, endPoint) => {
    const markerLength = 8;
    let leftMarker = null;
    let rightMarker = null;
    if (isHorizontal) {
        leftMarker = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: startPoint.x,
                y1: startPoint.y - markerLength / 2,
                x2: startPoint.x,
                y2: startPoint.y + markerLength / 2,
                id: `${groupId}_leftMarker`,
                stroke: "#000000",
                "stroke-width": 1,
            },
        });
        rightMarker = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: endPoint.x,
                y1: endPoint.y - markerLength / 2,
                x2: endPoint.x,
                y2: endPoint.y + markerLength / 2,
                id: `${groupId}_rightMarker`,
                stroke: "#000000",
                "stroke-width": 1,
            },
        });
    }
    else {
        leftMarker = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: startPoint.x - markerLength / 2,
                y1: startPoint.y,
                x2: startPoint.x + markerLength / 2,
                y2: startPoint.y,
                id: `${groupId}_topMarker`,
                stroke: "#000000",
                "stroke-width": 1,
            },
        });
        rightMarker = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: endPoint.x - markerLength / 2,
                y1: endPoint.y,
                x2: endPoint.x + markerLength / 2,
                y2: endPoint.y,
                id: `${groupId}_bottomMarker`,
                stroke: "#000000",
                "stroke-width": 1,
            },
        });
    }
    return { leftMarker, rightMarker };
};
const createMeasurementLines = (canvas, groupId, isHorizontal, startPoint, endPoint, midX, midY, textGap) => {
    let leftLine = null;
    let rightLine = null;
    if (isHorizontal) {
        leftLine = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: startPoint.x,
                y1: startPoint.y,
                x2: midX - textGap,
                y2: startPoint.y,
                id: `${groupId}_leftLine`,
                stroke: "#000000",
                "stroke-width": 1,
                "stroke-dasharray": "5,5",
            },
        });
        rightLine = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: midX + textGap,
                y1: endPoint.y,
                x2: endPoint.x,
                y2: endPoint.y,
                id: `${groupId}_rightLine`,
                stroke: "#000000",
                "stroke-width": 1,
                "stroke-dasharray": "5,5",
            },
        });
    }
    else {
        leftLine = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: startPoint.x,
                y1: startPoint.y,
                x2: startPoint.x,
                y2: midY - textGap,
                id: `${groupId}_topLine`,
                stroke: "#000000",
                "stroke-width": 1,
                "stroke-dasharray": "5,5",
            },
        });
        rightLine = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: endPoint.x,
                y1: midY + textGap,
                x2: endPoint.x,
                y2: endPoint.y,
                id: `${groupId}_bottomLine`,
                stroke: "#000000",
                "stroke-width": 1,
                "stroke-dasharray": "5,5",
            },
        });
    }
    return { leftLine, rightLine };
};
export const createMeasurementElement = ({ canvas, startPoint, endPoint, measurementText, groupId, }) => {
    const dx = endPoint.x - startPoint.x;
    const dy = endPoint.y - startPoint.y;
    const isHorizontal = Math.abs(dx) > Math.abs(dy);
    const midX = (startPoint.x + endPoint.x) / 2;
    const midY = (startPoint.y + endPoint.y) / 2;
    const group = canvas.addSVGElementsFromJson({
        element: "g",
        curStyles: false,
        attr: {
            id: groupId,
        },
    });
    const { leftMarker, rightMarker } = createMeasurementMarkers(canvas, groupId, isHorizontal, startPoint, endPoint);
    const estimatedTextWidth = measurementText.length * 8;
    const textGap = estimatedTextWidth / 2 + 3;
    const { leftLine, rightLine } = createMeasurementLines(canvas, groupId, isHorizontal, startPoint, endPoint, midX, midY, textGap);
    const textAttrs = {
        x: midX.toString(),
        y: midY.toString(),
        id: `${groupId}_text`,
        "font-size": "14",
        fill: "#000000",
        "font-family": "Roboto",
        stroke: "none",
        "text-anchor": "middle",
        "dominant-baseline": "middle",
    };
    if (!isHorizontal) {
        textAttrs.transform = `rotate(-90 ${midX} ${midY})`;
    }
    const textElem = canvas.addSVGElementsFromJson({
        element: "text",
        curStyles: false,
        attr: textAttrs,
    });
    if (textElem) {
        textElem.textContent = measurementText;
    }
    if (group) {
        if (leftMarker)
            group.appendChild(leftMarker);
        if (rightMarker)
            group.appendChild(rightMarker);
        if (leftLine)
            group.appendChild(leftLine);
        if (rightLine)
            group.appendChild(rightLine);
        if (textElem)
            group.appendChild(textElem);
    }
    return group || leftLine || rightLine || textElem;
};
export const getElementMeasurement = (element) => {
    let lengthInPixels = 0;
    let bbox;
    let isHorizontal = false;
    if (element instanceof SVGLineElement) {
        const x1 = parseFloat(element.getAttribute("x1") || "0");
        const y1 = parseFloat(element.getAttribute("y1") || "0");
        const x2 = parseFloat(element.getAttribute("x2") || "0");
        const y2 = parseFloat(element.getAttribute("y2") || "0");
        const dx = Math.abs(x2 - x1);
        const dy = Math.abs(y2 - y1);
        isHorizontal = dx > dy;
        lengthInPixels = Math.sqrt(dx * dx + dy * dy);
        bbox = element.getBBox();
    }
    else if (element instanceof SVGPathElement) {
        lengthInPixels = element.getTotalLength();
        bbox = element.getBBox();
        isHorizontal = bbox.width > bbox.height;
    }
    else if (element instanceof SVGGeometryElement && typeof element.getTotalLength === "function") {
        lengthInPixels = element.getTotalLength();
        bbox = element.getBBox();
        isHorizontal = bbox.width > bbox.height;
    }
    else {
        return null;
    }
    return { lengthInPixels, isHorizontal, bbox };
};
